<template>
  <div class="footer__lower container container--page-content bg-white text-primary py-12 md:py-20">
    <div class="footer__logo-section mb-10 md:mb-8">
      <NuxtLink to="/" class="header__logo" aria-label="Home" :title="t('header.logo.title')">
        <SharedPicture
          :media="siteOptions?.data?.siteLogo"
          alt="Herbert Seidl Logo"
          image-class="header__logo-image block !h-[44px] !w-[215px] lg:!h-[50px] lg:!w-[245px] object-contain object-center"
          :quality="100"
          width="245"
          height="50"
          loading="lazy"
        />
      </NuxtLink>
      <!-- INFO: Only german language for now -->
      <!-- <HeaderLanguageSwitcher /> -->
    </div>
    <div class="footer__lower-main flex flex-col gap-10 pb-10 lg:grid lg:grid-cols-4 lg:gap-10 md:pb-20">
      <div class="footer__lower-main-menu flex flex-col gap-10 md:gap-8">
        <FooterLowerFooterMenu v-if="siteOptions?.data?.footerMenus?.length" :menu-items="siteOptions.data.footerMenus" />

        <FooterLowerFooterSocilals />
      </div>

      <div class="footer__location-section-wrapper flex flex-col gap-10 md:flex-row md:justify-between lg:col-span-3">
        <div class="footer__location-section flex flex-col gap-6">
          <div class="footer__location-title h5">Standort Gleisdorf</div>
          <div class="footer__location-address flex gap-2 text-regular-normal not-italic">
            <svg class="text-accent mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M10.0001 12.2344C11.8384 12.2344 13.3334 10.7394 13.3334 8.90104C13.3334 7.06271 11.8384 5.56771 10.0001 5.56771C8.16176 5.56771 6.66676 7.06271 6.66676 8.90104C6.66676 10.7394 8.16176 12.2344 10.0001 12.2344ZM10.0001 7.23438C10.9193 7.23438 11.6668 7.98188 11.6668 8.90104C11.6668 9.82021 10.9193 10.5677 10.0001 10.5677C9.08092 10.5677 8.33343 9.82021 8.33343 8.90104C8.33343 7.98188 9.08092 7.23438 10.0001 7.23438Z"
                fill="currentColor"
              />
              <path
                d="M9.51678 18.746C9.65782 18.8468 9.8268 18.9009 10.0001 18.9009C10.1734 18.9009 10.3424 18.8468 10.4834 18.746C10.7368 18.5669 16.6909 14.2677 16.6668 8.90104C16.6668 5.22521 13.6759 2.23438 10.0001 2.23438C6.32428 2.23438 3.33345 5.22521 3.33345 8.89688C3.30928 14.2677 9.26345 18.5669 9.51678 18.746ZM10.0001 3.90104C12.7576 3.90104 15.0001 6.14354 15.0001 8.90521C15.0176 12.6035 11.3434 15.9244 10.0001 17.0135C8.65761 15.9235 4.98261 12.6019 5.00011 8.90104C5.00011 6.14354 7.24261 3.90104 10.0001 3.90104Z"
                fill="currentColor"
              />
            </svg>
            <div class="footer__location-address-text text-regular-semibold !text-base flex flex-col gap-0">
              <p>8200 Gleisdorf</p>
              <p>Neugasse 102 - 103</p>
            </div>
          </div>
          <div class="footer__location-opening-hours flex gap-2 text-regular-normal">
            <svg class="text-accent mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M10 3.90072C5.93418 3.90072 2.50001 7.33488 2.50001 11.4007C2.50001 15.4665 5.93418 18.9007 10 18.9007C14.0658 18.9007 17.5 15.4665 17.5 11.4007C17.5 7.33488 14.0658 3.90072 10 3.90072ZM10 17.234C6.83834 17.234 4.16668 14.5624 4.16668 11.4007C4.16668 8.23905 6.83834 5.56738 10 5.56738C13.1617 5.56738 15.8333 8.23905 15.8333 11.4007C15.8333 14.5624 13.1617 17.234 10 17.234Z"
                fill="currentColor"
              />
              <path
                d="M10.8333 10.5674V7.23406H9.16666V12.2341H14.1667V10.5674H10.8333ZM14.4033 3.65656L15.58 2.47656L18.0883 4.97656L16.9108 6.1574L14.4033 3.65656ZM5.58166 3.65656L3.08999 6.15573L1.90833 4.97906L4.39999 2.47906L5.58166 3.65656Z"
                fill="currentColor"
              />
            </svg>
            <table class="text-regular-semibold">
              <tbody>
                <tr>
                  <td class="pr-4">Mo-Fr:</td>
                  <td><time datetime="09:00">09:00</time> - <time datetime="18:00">18:00</time> Uhr</td>
                </tr>
                <tr>
                  <td>Sa:</td>
                  <td><time datetime="08:00">08:00</time> - <time datetime="13:00">13:00</time> Uhr</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="footer__location-section flex flex-col gap-6">
          <div class="footer__location-title h5">Standort Gleisdorf-Süd</div>
          <div class="footer__location-address flex gap-2 text-regular-normal not-italic">
            <svg class="text-accent mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M10.0001 12.2344C11.8384 12.2344 13.3334 10.7394 13.3334 8.90104C13.3334 7.06271 11.8384 5.56771 10.0001 5.56771C8.16176 5.56771 6.66676 7.06271 6.66676 8.90104C6.66676 10.7394 8.16176 12.2344 10.0001 12.2344ZM10.0001 7.23438C10.9193 7.23438 11.6668 7.98188 11.6668 8.90104C11.6668 9.82021 10.9193 10.5677 10.0001 10.5677C9.08092 10.5677 8.33343 9.82021 8.33343 8.90104C8.33343 7.98188 9.08092 7.23438 10.0001 7.23438Z"
                fill="currentColor"
              />
              <path
                d="M9.51678 18.746C9.65782 18.8468 9.8268 18.9009 10.0001 18.9009C10.1734 18.9009 10.3424 18.8468 10.4834 18.746C10.7368 18.5669 16.6909 14.2677 16.6668 8.90104C16.6668 5.22521 13.6759 2.23438 10.0001 2.23438C6.32428 2.23438 3.33345 5.22521 3.33345 8.89688C3.30928 14.2677 9.26345 18.5669 9.51678 18.746ZM10.0001 3.90104C12.7576 3.90104 15.0001 6.14354 15.0001 8.90521C15.0176 12.6035 11.3434 15.9244 10.0001 17.0135C8.65761 15.9235 4.98261 12.6019 5.00011 8.90104C5.00011 6.14354 7.24261 3.90104 10.0001 3.90104Z"
                fill="currentColor"
              />
            </svg>
            <div class="footer__location-address-text text-regular-semibold !text-base flex flex-col gap-0">
              <p>8200 Gleisdorf</p>
              <p>Hofstätten 221</p>
            </div>
          </div>
          <div class="footer__location-opening-hours flex gap-2 text-regular-normal">
            <svg class="text-accent mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M10 3.90072C5.93418 3.90072 2.50001 7.33488 2.50001 11.4007C2.50001 15.4665 5.93418 18.9007 10 18.9007C14.0658 18.9007 17.5 15.4665 17.5 11.4007C17.5 7.33488 14.0658 3.90072 10 3.90072ZM10 17.234C6.83834 17.234 4.16668 14.5624 4.16668 11.4007C4.16668 8.23905 6.83834 5.56738 10 5.56738C13.1617 5.56738 15.8333 8.23905 15.8333 11.4007C15.8333 14.5624 13.1617 17.234 10 17.234Z"
                fill="currentColor"
              />
              <path
                d="M10.8333 10.5674V7.23406H9.16666V12.2341H14.1667V10.5674H10.8333ZM14.4033 3.65656L15.58 2.47656L18.0883 4.97656L16.9108 6.1574L14.4033 3.65656ZM5.58166 3.65656L3.08999 6.15573L1.90833 4.97906L4.39999 2.47906L5.58166 3.65656Z"
                fill="currentColor"
              />
            </svg>
            <table class="text-regular-semibold">
              <tbody>
                <tr>
                  <td class="pr-4">Mo-Fr:</td>
                  <td><time datetime="09:00">09:00</time> - <time datetime="18:00">18:00</time> Uhr</td>
                </tr>
                <tr>
                  <td>Sa:</td>
                  <td><time datetime="08:00">08:00</time> - <time datetime="13:00">13:00</time> Uhr</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="footer__location-section flex flex-col gap-6">
          <div class="footer__location-title h5">Standort Oberwart</div>
          <div class="footer__location-address flex gap-2 text-regular-normal not-italic">
            <svg class="text-accent mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M10.0001 12.2344C11.8384 12.2344 13.3334 10.7394 13.3334 8.90104C13.3334 7.06271 11.8384 5.56771 10.0001 5.56771C8.16176 5.56771 6.66676 7.06271 6.66676 8.90104C6.66676 10.7394 8.16176 12.2344 10.0001 12.2344ZM10.0001 7.23438C10.9193 7.23438 11.6668 7.98188 11.6668 8.90104C11.6668 9.82021 10.9193 10.5677 10.0001 10.5677C9.08092 10.5677 8.33343 9.82021 8.33343 8.90104C8.33343 7.98188 9.08092 7.23438 10.0001 7.23438Z"
                fill="currentColor"
              />
              <path
                d="M9.51678 18.746C9.65782 18.8468 9.8268 18.9009 10.0001 18.9009C10.1734 18.9009 10.3424 18.8468 10.4834 18.746C10.7368 18.5669 16.6909 14.2677 16.6668 8.90104C16.6668 5.22521 13.6759 2.23438 10.0001 2.23438C6.32428 2.23438 3.33345 5.22521 3.33345 8.89688C3.30928 14.2677 9.26345 18.5669 9.51678 18.746ZM10.0001 3.90104C12.7576 3.90104 15.0001 6.14354 15.0001 8.90521C15.0176 12.6035 11.3434 15.9244 10.0001 17.0135C8.65761 15.9235 4.98261 12.6019 5.00011 8.90104C5.00011 6.14354 7.24261 3.90104 10.0001 3.90104Z"
                fill="currentColor"
              />
            </svg>
            <div class="footer__location-address-text text-regular-semibold !text-base flex flex-col gap-0">
              <p>7400 Oberwart</p>
              <p>Wiener Strasse 101</p>
            </div>
          </div>
          <div class="footer__location-opening-hours flex gap-2 text-regular-normal">
            <svg class="text-accent mt-[2px]" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <path
                d="M10 3.90072C5.93418 3.90072 2.50001 7.33488 2.50001 11.4007C2.50001 15.4665 5.93418 18.9007 10 18.9007C14.0658 18.9007 17.5 15.4665 17.5 11.4007C17.5 7.33488 14.0658 3.90072 10 3.90072ZM10 17.234C6.83834 17.234 4.16668 14.5624 4.16668 11.4007C4.16668 8.23905 6.83834 5.56738 10 5.56738C13.1617 5.56738 15.8333 8.23905 15.8333 11.4007C15.8333 14.5624 13.1617 17.234 10 17.234Z"
                fill="currentColor"
              />
              <path
                d="M10.8333 10.5674V7.23406H9.16666V12.2341H14.1667V10.5674H10.8333ZM14.4033 3.65656L15.58 2.47656L18.0883 4.97656L16.9108 6.1574L14.4033 3.65656ZM5.58166 3.65656L3.08999 6.15573L1.90833 4.97906L4.39999 2.47906L5.58166 3.65656Z"
                fill="currentColor"
              />
            </svg>
            <table class="text-regular-semibold">
              <tbody>
                <tr>
                  <td class="pr-4">Mo-Fr:</td>
                  <td><time datetime="09:00">09:00</time> - <time datetime="18:00">18:00</time> Uhr</td>
                </tr>
                <tr>
                  <td>Sa:</td>
                  <td><time datetime="08:00">08:00</time> - <time datetime="12:00">12:00</time> Uhr</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <FooterLowerFooterLegal />
  </div>
</template>

<script lang="ts" setup>
  import type { SiteOption, StrapiResponse } from '~/types/strapi';
  const { t } = useI18n();

  const siteOptions = inject<Ref<StrapiResponse<SiteOption> | null>>('siteOptions');
</script>
<style lang="scss" scoped></style>
